import { REQUEST, SUCCESS, FAILURE } from '../../../utils/actionGenerator';
import {
  ADD_CS_AGENT,
  SUPPORT_AGENT_UPDATE,
  RESET_TICKET_ASSIGNMENT,
  GET_SUPPORT_AGENT_TEAMS,
  GET_TICKET_ASSIGNMENT_DATA,
  SET_TICKET_ASSIGNMENT_SELECTED_TEAM,
} from './actions';

const initialState = {
  data: [],
  teams: [],
  error: null,
  loading: false,
  teamsError: null,
  selectedTeam: null,
  teamsLoading: false,
  addAgentError: null,
  addAgentLoading: false,
  supportAgentUpdateLoading: false,
  lastAgentsQuery: { page: 0, size: 10 },
};

const ticketAssignmentReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_TICKET_ASSIGNMENT_DATA[REQUEST]: {
      const p = action.params || {};
      const page = p.page ?? state.lastAgentsQuery?.page ?? 0;
      const size = p.size ?? state.lastAgentsQuery?.size ?? 10;
      const emailTrimmed = typeof p.email === 'string' ? p.email.trim() : '';
      const teamParam = typeof p.team === 'string' && p.team.trim() ? p.team.trim() : '';
      const lastAgentsQuery =
        emailTrimmed.length > 0
          ? { page, size, email: emailTrimmed }
          : teamParam
            ? { page, size, team: teamParam }
            : { ...state.lastAgentsQuery, page, size };

      return {
        ...state,
        loading: true,
        error: null,
        lastAgentsQuery,
      };
    }

    case GET_TICKET_ASSIGNMENT_DATA[SUCCESS]:
      return {
        ...state,
        loading: false,
        data: action.response,
        error: null,
      };

    case GET_TICKET_ASSIGNMENT_DATA[FAILURE]:
      return {
        ...state,
        loading: false,
        error: action.response,
      };

    case ADD_CS_AGENT[REQUEST]:
      return {
        ...state,
        addAgentLoading: true,
        addAgentError: null,
      };

    case ADD_CS_AGENT[SUCCESS]:
      return {
        ...state,
        addAgentLoading: false,
        addAgentError: null,
      };

    case ADD_CS_AGENT[FAILURE]:
      return {
        ...state,
        addAgentLoading: false,
        addAgentError: action.response,
      };

    case SUPPORT_AGENT_UPDATE[REQUEST]:
      return {
        ...state,
        supportAgentUpdateLoading: true,
      };

    case SUPPORT_AGENT_UPDATE[SUCCESS]:
      return {
        ...state,
        supportAgentUpdateLoading: false,
      };

    case SUPPORT_AGENT_UPDATE[FAILURE]:
      return {
        ...state,
        supportAgentUpdateLoading: false,
      };

    case RESET_TICKET_ASSIGNMENT:
      return initialState;

    case GET_SUPPORT_AGENT_TEAMS[REQUEST]:
      return {
        ...state,
        loading: true,
        teamsError: null,
        teamsLoading: false,
      };

    case GET_SUPPORT_AGENT_TEAMS[SUCCESS]: {
      const teams = Array.isArray(action.response?.teams) ? action.response.teams : [];
      return {
        ...state,
        teams,
        teamsError: null,
        teamsLoading: false,
        selectedTeam: teams[0] || null,
        loading: teams.length > 0 ? state.loading : false,
      };
    }

    case GET_SUPPORT_AGENT_TEAMS[FAILURE]:
      return {
        ...state,
        teams: [],
        loading: false,
        teamsLoading: false,
        teamsError: action.response,
        selectedTeam: null,
      };

    case SET_TICKET_ASSIGNMENT_SELECTED_TEAM:
      return {
        ...state,
        selectedTeam: action.team,
      };

    default:
      return state;
  }
};

export const getTicketAssignmentReducer = (state) => state.ticketAssignment || initialState;

export default ticketAssignmentReducer;
